export default "__VITE_ASSET__DqH$j5ZY__"